
    import {ISecurityOfficer} from '../components/SecurityOfficer/ISecurityOfficer'
    import {SecurityOfficer} from '../components/SecurityOfficer/SecurityOfficer'
    import {onMounted, ref} from "vue";
    import { numberLiteralTypeAnnotation } from '@babel/types';
    import router from '@/router';
    export default({
        name:"profileView",
        props:['baseUrl'],
        setup(props:any){
            const isEntryMode = ref(true);
            const cityList = ref([]) as any;
            const companies = ref([]);
            const conveyanceListArray = ref([{id:1, name:"Car"},  {id:2, name:"Motor Bike"}, {id:3, name:"Public Tpt"}, {id:4, name:"Bike"},]);
            const selectedConveyanceName = ref("");
            const selectedCityName = ref("");
            const genderList = ref([]) as any;
            const documentTypesList = ref([]) as any;
            const nationalityList = ref([]) as any;
            const selectedGenderType = ref("");
            const selectedNationality = ref("");
            const selectedCountryOfBirth = ref("");
            const selectedAddressCountry = ref("");
            const idDocumentNumber = ref("");
            const selectedIdDocumentCountryOfIssue = ref("");
            const selectedIdDocumentTypeName = ref("");
            const selectedIdDocumentId = ref("");
            
            var officerId = localStorage.getItem("OfficerId")!;

            const securityOfficerObject = ref<SecurityOfficer>() as any;
            const isPrivacyPolicyAgreed = ref(false);// as boolean;
          
            const getCityList = ()=> {
                    let sitesRequestUrl = props.baseUrl + "Cities/Cities";
                    let sitesRequestOptions = {
                        method:"GET",
                        headers:{
                        "Authorization":"Bearer " + localStorage.Guardtoken,
                        "Content-Type" : "application/json"
                        },
                    };
                    fetch(sitesRequestUrl, sitesRequestOptions)
                    .then(response =>{
                        var result = response.json();
                        return result;
                    })
                    .then(res =>{
                        cityList.value = res.cities;
                        return res;
                    });
                }
                
            const dateToYYYYMMDD = (d: Date) => {
                // alternative implementations in https://stackoverflow.com/q/23593052/1850609
                return (
                  new Date(d)
                    // .toLocaleString("en-GB", { timeZone: "UTC" })
                    .toLocaleString()
                    .substring(0, 10)
                );
              }
              
            const getCompaniesList = ()=>{
                    let clientsRequestUrl = props.baseUrl + "Companies/Companies";
                    let clientsRequestOptions = {
                        method:"GET",
                        headers:{
                        'Authorization': `Bearer ${localStorage.Guardtoken}`,
                            "Content-Type":"application/json",
                        }
                    };

                    fetch(clientsRequestUrl, clientsRequestOptions)
                    .then( response =>response.json())
                    .then(reslt =>{
                        companies.value = reslt;
                    });
                }

            const getUtilityLists = ()=>{
                  let requestUrl = props.baseUrl + "SecurityOfficers/GenderAndDocumentTypesAndNationalityList";
                  let requestoptions = {
                    method:"GET",
                    headers:{
                      "Authorization":"Bearer " + localStorage.Guardtoken,
                      "Content-Type":"application/json"
                    },
                  }

                  fetch(requestUrl, requestoptions)
                  .then( response => {
                    let res = response.json();
                    return res;
                  })
                  .then(  r => {
                    genderList.value =r.utilityService.gendersList;
                    documentTypesList.value =r.utilityService.documentTypesList;
                    nationalityList.value = r.utilityService.nationalityList;
                  });

                }

                getUtilityLists();
                getCityList();
                getCompaniesList();

            const UpdateOfficer = ()=>{
              alert("Please wait while the record is being saved!")
              if(isPrivacyPolicyAgreed.value == false)
              {
                alert("Please, first read the privace policy given in the above link and agree to terms and conditions.")
                return;
              }
              let cityId = cityList.value.find((c:any)=>c.name == selectedCityName.value)?.cityId as any;
              if(cityId > 0 == false)
              {
                alert("Please select a city form the drop-down list")
                return;
              }

              let selectedGenderId = genderList.value.find((g:any) => g.name == selectedGenderType.value)?.id as any;
              if(selectedGenderId <= 0)
              {
                alert("Please select gender form the drop-down list")
                return;
              }

              let selectedNationalityId = nationalityList.value.find( (n:any) => n.name == selectedNationality.value)?.id as any;
              if(selectedNationalityId < 0)
              {
                alert("Please select nationality form the drop-down list")
                return;
              }
               
              let selectedCountryOfBirthId = nationalityList.value.find( (n:any) => n.name == selectedCountryOfBirth.value)?.id as any;
              if(selectedCountryOfBirthId < 0)
              {
                alert("Please select birth country form the drop-down list")
                return;
              }

              let selectedAddressCountryId = nationalityList.value.find( (n:any) => n.name == selectedAddressCountry.value)?.id as any;
              if(selectedAddressCountryId < 0)
              {
                alert("Please select address country form the drop-down list")
                return;
              }

              securityOfficerObject.value.CityId = cityId;

              let conveyanceId = conveyanceListArray.value.find(c=> c.name == selectedConveyanceName.value)?.id as any;
              if(conveyanceId > 0 == false)
              {
                alert("Please select a conveyance type form the drop-down list")
                return;
              }
              securityOfficerObject.value.ConveyanceId = conveyanceId;

              let documentTypeId = documentTypesList.value.find((d:any)=> d.name == selectedIdDocumentTypeName.value)?.id as any;
              if(documentTypeId > 0 == false)
              {
                alert("Please select a document-type form the drop-down list")
                return;
              }
              securityOfficerObject.value.IdDocumentTypeId = documentTypeId;
              

              let selectedIdDocumentCountryOfIssueId = nationalityList.value.find((n:any)=> n.name == selectedIdDocumentCountryOfIssue.value)?.id as any;
              if(selectedIdDocumentCountryOfIssueId > 0 == false)
              {
                alert("Please select a country-ofissue form the drop-down list")
                return;
              }
              

              let addOfficerRequestUrl = props.baseUrl + "SecurityOfficers/UpdateSecurityOfficerByOfficerHimself";//UpdateSecurityOfficer";
              let addOfficerrequestOptions = {
                method:"POST",
                headers:{
                  "Authorization":`Bearer ${localStorage.Guardtoken}`,
                  "Content-Type":"application/json"
                },
                body:JSON.stringify({
                  "SecurityOfficerId":securityOfficerObject.value.SecurityOfficerId,
                  "FirstName":securityOfficerObject.value.FirstName,
                  "LastName": securityOfficerObject.value.LastName,
                  "PostCode": securityOfficerObject.value.PostCode,
                  //"CityId": parseInt(securityOfficerObject.value.CityId),//1,//
                  "CityId": cityId,//1,//
                  "County": securityOfficerObject.value.County,
                  "StreetAdress": securityOfficerObject.value.StreetAdress,
                  "Town": securityOfficerObject.value.Town,
                  "Active": securityOfficerObject.value.Active,
                  "SecurityCompanyId": 3,//parseInt( securityOfficerObject.value.SecurityCompanyId),//2,//
                  "SiabadageNumber": securityOfficerObject.value.SiabadageNumber,
                  "MobileNumber": securityOfficerObject.value.MobileNumber,
                  "Ninumber": securityOfficerObject.value.Ninumber,
                  "DesignationId": null,//securityOfficerObject.value.DesignationId,
                  "DeptId": null,//securityOfficerObject.value.DeptId,
                  "PassportId": securityOfficerObject.value.PassportId,
                  "ConveyanceId": parseInt( securityOfficerObject.value.ConveyanceId),
                  "Email":securityOfficerObject.value.Email,
                  "SiaExpiryDate":securityOfficerObject.value.SiaExpiryDate,
                  "Phone2":securityOfficerObject.value.Phone2,
                  "NextOfKin":securityOfficerObject.value.NextOfKin,
                  "PreviouslyKnownAS":securityOfficerObject.value.PreviouslyKnownAs,
                  "DateOfBirth":securityOfficerObject.value.DateOfBirth,
                  "PlaceOfBirth":securityOfficerObject.value.PlaceOfBirth,
                  "HouseNameNumber":securityOfficerObject.value.HouseNameNumber,
                  "IdentityDocumentId":securityOfficerObject.value.IdentityDocumentId,
                  "CountryOfBirthId": selectedCountryOfBirthId,
                  "AddressCountryId": selectedAddressCountryId,
                  "NationalityId":selectedNationalityId,
                  "GenderId": selectedGenderId,
                  "IdentityDocument": { 'Id':securityOfficerObject.value.identityDocumentId, 'IssueDate':securityOfficerObject.value.IdDocumentInfo.issueDate, 'ExpiryDate':securityOfficerObject.value.IdDocumentInfo.expiryDate, 'CountryOfIssueId':selectedIdDocumentCountryOfIssueId, 'Number':securityOfficerObject.value.IdDocumentInfo.number, 'TypeId':documentTypeId},
                  //"PayRate": parseFloat( securityOfficerObject.value.PayRate)
                })
              };

              fetch(addOfficerRequestUrl, addOfficerrequestOptions)
              .then(response =>{
                if(response.ok == true)
                {
                  alert("Update Officer succeeded.")
                  // router.push("schedule");
                  router.push("documents");
                }
                else
                  alert("Update Officer Failed. Try again.")
              })
        }
    
        const  GetOfficerFullDetailById = () =>{
          
          if(genderList == null || genderList == undefined|| genderList == 'undefined')
          {
            console.log("genderList method called");
            getUtilityLists();
          }

          if(cityList == null || cityList == undefined|| cityList == 'undefined')
          {
            console.log("getCityList method called");
            getCityList();
          }

          let GetOfficerFullDetailByIdRequestUrl = props.baseUrl + "securityofficers/OfficerFullDetailById";
          let GetOfficerFullDetailByIdRequestOptions = {
            method:"Post",
            headers:{
              "Authorization":`Bearer ${localStorage.Guardtoken}`,
              "Content-Type":"application/json"
            },
            body: JSON.stringify({
              "Id": parseInt(officerId)
            })
          };
          fetch(GetOfficerFullDetailByIdRequestUrl, GetOfficerFullDetailByIdRequestOptions)
          .then(response =>
          {
            var result = response.json();
            return result;
          })
          .then(res => {
            let companyInfo ="";
            companies.value.filter( function(c:any)
            {
              if(c.companyId == res.officerFullDetailViewModel.securityCompanyId)
                companyInfo = c.companyId + "-" + c.companyName;
            });

          //console.log("res.officerFullDetailViewModel.IdDocumentCountryOfIssueId" , res.officerFullDetailViewModel)

          securityOfficerObject.value = new SecurityOfficer(res.officerFullDetailViewModel.securityOfficerId,
              res.officerFullDetailViewModel.firstName,
              res.officerFullDetailViewModel.lastName,
              res.officerFullDetailViewModel.postCode,
              res.officerFullDetailViewModel.cityId,//cityInfo,//
              res.officerFullDetailViewModel.county,
              res.officerFullDetailViewModel.streetAdress,
              res.officerFullDetailViewModel.town,
              true,
              res.officerFullDetailViewModel.securityCompanyId,//companyInfo,//
              res.officerFullDetailViewModel.siabadageNumber,
              res.officerFullDetailViewModel.mobileNumber,
              res.officerFullDetailViewModel.ninumber,
              res.officerFullDetailViewModel.designationId,
              res.officerFullDetailViewModel.deptId,
              res.officerFullDetailViewModel.passportId,
              res.officerFullDetailViewModel.conveyanceId,
              res.officerFullDetailViewModel.email,//'e@mail.com',
              res.officerFullDetailViewModel.siaExpiryDate,//new Date(),
              res.officerFullDetailViewModel.phone2,//'phone',
              res.officerFullDetailViewModel.nextOfKin,//'kin',
              res.officerFullDetailViewModel.payRate,//'131',
              res.officerFullDetailViewModel.previouslyKnownAs,//'131',
              res.officerFullDetailViewModel.dateOfBirth,//'131',
              res.officerFullDetailViewModel.placeOfBirth,//'131',
              res.officerFullDetailViewModel.houseNameNumber,//'131',
              res.officerFullDetailViewModel.identityDocumentId,//'131',
              res.officerFullDetailViewModel.countryOfBirthId,//'131',
              res.officerFullDetailViewModel.nationalityId,//'131',
              res.officerFullDetailViewModel.genderId,//'131',
              res.officerFullDetailViewModel.addressCountryId,//'131',
              res.officerFullDetailViewModel.identityDocument,//.resolve(),//'131',
            );

            //console.log("res.officerFullDetailViewModel", res.officerFullDetailViewModel);
            // console.log("res.officerFullDetailViewModel.identityDocument", res.officerFullDetailViewModel.identityDocument);
            // console.log("securityOfficerObject.value.IdDocument", securityOfficerObject.value.IdDocumentInfo);
           
            let cityObject = cityList.value.find( (c:any) =>
              (c.cityId == res.officerFullDetailViewModel.cityId)
            );
          
            selectedGenderType.value = genderList.value.find((g:any)=>g.id == res.officerFullDetailViewModel.genderId)?.name;
            selectedCityName.value = cityObject?.name;
            selectedConveyanceName.value = conveyanceListArray.value.find(c=> c.id == securityOfficerObject.value.ConveyanceId)?.name as any;
            selectedNationality.value = nationalityList.value.find((n:any) => n.id == res.officerFullDetailViewModel.nationalityId)?.name as any;
            selectedCountryOfBirth.value = nationalityList.value.find((n:any) => n.id == res.officerFullDetailViewModel.countryOfBirthId)?.name as any;
            selectedAddressCountry.value = nationalityList.value.find((n:any) => n.id == res.officerFullDetailViewModel.addressCountryId)?.name as any;
            // selectedIdDocumentCountryOfIssue.value = nationalityList.value.find((n:any) => n.id == res.officerFullDetailViewModel.IdDocumentCountryOfIssueId)?.name as any;
            selectedIdDocumentCountryOfIssue.value = nationalityList.value.find((n:any) => n.id == res.officerFullDetailViewModel.identityDocument.countryOfIssueId)?.name as any;
            // alert("selectedIdDocumentCountryOfIssue.value" + selectedIdDocumentCountryOfIssue.value)

            selectedIdDocumentTypeName.value = documentTypesList.value.find((n:any) => n.id == res.officerFullDetailViewModel.identityDocument.typeId)?.name as any;

          })
          .catch(Error => {
            console.log("error ", Error);
            securityOfficerObject.value = null;
          });
        }

        GetOfficerFullDetailById();
    
          return{
              isEntryMode,
              securityOfficerObject,
              cityList,
              companies,
              getCityList,
              UpdateOfficer,
              GetOfficerFullDetailById,
              conveyanceListArray,
              selectedConveyanceName,
              selectedCityName,
              isPrivacyPolicyAgreed,
              dateToYYYYMMDD,
              getUtilityLists,
              genderList,
              selectedGenderType,
              selectedNationality,
              nationalityList,
              selectedCountryOfBirth,
              selectedAddressCountry,
              documentTypesList,
              idDocumentNumber,
              selectedIdDocumentCountryOfIssue,
              selectedIdDocumentName: selectedIdDocumentTypeName,
              selectedIdDocumentId,

          }
        },
    });
    